import SectionHeading from '@/pages/home/components/SectionHeading';
import { noticeItems } from '@/mocks/cinemaData';

export default function NoticeSection() {
  return (
    <section id="notice" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="使用须知"
          title="浏览与使用时的几点提醒"
          desc="无论使用哪一种访问方式，下面这几条都值得先看一眼。它们不针对某个具体站点，而是通用的上网安全习惯。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2">
          {noticeItems.map((item) => (
            <article key={item.title} className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className={`${item.icon} text-xl`} aria-hidden="true" />
              </span>
              <div>
                <h3 className="font-heading text-base font-semibold text-foreground-950">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}